import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthProvider";
import "./navbar.css";
import axios from "axios";
import miraiLogo from "../assest/mirai-logo.png";
import MobileNav from "./MobileNav";

const News = [
  {
    id: "1",
    category: "tax",
  },
  {
    id: "2",
    category: "labor",
  },
  {
    id: "3",
    category: "general",
  },
  {
    id: "4",
    category: "FDI",
  },
];

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);

  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const [isDropdownVisibleAboutUs, setDropdownVisibleAboutUs] = useState(false);

  const toggleDropdownAboutUs = (visible) => {
    setDropdownVisibleAboutUs(visible);
  };

  const [isDropdownVisibleService, setDropdownVisibleService] = useState(false);

  const toggleDropdownService = (visible) => {
    setDropdownVisibleService(visible);
  };

  const [isDropdownVisibleNews, setDropdownVisibleNews] = useState(false);

  const toggleDropdownNews = (visible) => {
    setDropdownVisibleNews(visible);
  };

  const [services, setServices] = useState([]); // State to store services
  const [loading, setLoading] = useState(true); // State for loading indicator

  useEffect(() => {
    // Fetch services data
    const fetchServices = async () => {
      try {
        const response = await axios.get(
          "https://mirai-server.vercel.app/service-main"
        );
        setServices(response.data); // Update state with fetched data
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error("Error fetching services:", error);
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  // State to manage sidebar visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Close sidebar function
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  // Close sidebar when clicking outside of it
  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      closeSidebar();
    }
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside); // Use `mousedown` for better detection
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <div>
      <div className="sticky top-0 z-50 ">
        <div className="px-5 sm:hidden bg-white flex justify-end">
          {user ? (
            <div class="flex gap-2 lg:order-2 space-x-2 lg:space-x-0 rtl:space-x-reverse">
              <Link
                to="/dashboard"
                class="lg:text-md sm:text-sm text-blue-900 font-jost"
              >
                DASHBOARD
              </Link>
              <button
                onClick={logout}
                class="lg:text-md sm:text-sm text-blue-400 font-jost"
              >
                LOG OUT
              </button>
            </div>
          ) : (
            <div class="flex gap-4 lg:order-2 space-x-2 lg:space-x-0 rtl:space-x-reverse">
              <Link
                to="login"
                class="lg:text-md sm:text-sm text-blue-600 font-jost"
              >
                Log In
              </Link>
              <Link
                to="signUp"
                class="lg:text-md sm:text-sm text-blue-600 font-jost"
              >
                Sign Up
              </Link>
            </div>
          )}
        </div>
        <div className="">
          <nav class=" bg-white lg:pb-4 sm:pb-2  w-full  border-b border-gray-200 ">
            <div class="max-w-screen-sm flex flex-wrap items-center justify-between mx-auto p-4">
              <Link
                to="/"
                class="flex items-center space-x-3 rtl:space-x-reverse"
              >
                <img src={miraiLogo} class="h-10" alt="Flowbite Logo" />
                <span class="self-center font-jost lg:text-2xl sm:text-md text-gray-800  whitespace-nowrap dark:text-white">
                  MIRAI Consulting Bangladesh Ltd.
                </span>
              </Link>
              <button onClick={toggleSidebar} className="lg:hidden">
                <img
                  className="w-8 h-8 lg:hidden"
                  alt=""
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxnIGZpbGw9IiMyMTk2ZjMiPjxwYXRoIGQ9Ik0yMSA2SDNhMSAxIDAgMSAwIDAgMmgxOGExIDEgMCAxIDAgMC0yek0xNSAxMUgzYTEgMSAwIDEgMCAwIDJoMTJhMSAxIDAgMSAwIDAtMnpNOSAxNkgzYTEgMSAwIDEgMCAwIDJoNmExIDEgMCAxIDAgMC0yeiIgZmlsbD0iIzIxOTZmMyIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzIxOTZmMyIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L2c+PC9zdmc+"
                />
              </button>
              <div
                ref={sidebarRef}
                className={`sidebarMirai ${isSidebarOpen ? "open" : ""}`}
              >
                <div className="flex justify-center gap-5 items-start flex-col px-5 py-10">
                  <MobileNav services={services} closeSidebar={closeSidebar} />
                </div>
              </div>
              {/* <div
                className={`overlay ${isSidebarOpen ? "active" : ""}`}
                onClick={toggleSidebar}
              ></div> */}
              <div
                class="items-center justify-between hidden w-full lg:flex lg:w-auto lg:order-1"
                id="navbar-sticky"
              >
                <ul class="flex flex-col p-4 lg:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 lg:space-x-8 rtl:space-x-reverse lg:flex-row lg:mt-0 lg:border-0 lg:bg-white dark:bg-gray-800 lg:dark:bg-gray-900 dark:border-gray-700">
                  <li>
                    <Link
                      to="/"
                      className={`block py-2 px-3 rounded font-jost ${
                        isActive("/")
                          ? "customBlue font-bold"
                          : "text-gray-900 lg:hover:customBlue"
                      } hover:bg-gray-100 text-xl lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent`}
                      aria-current="page"
                    >
                      HOME
                    </Link>
                  </li>
                  <li>
                    <div
                      onMouseEnter={() => toggleDropdownAboutUs(true)}
                      onMouseLeave={() => toggleDropdownAboutUs(false)}
                    >
                      <button
                        className={`block py-2 px-3 rounded cursor-pointer hover:bg-gray-100 uppercase text-xl text-md font-jost   lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent ${
                          location.pathname === "/bangladesh-subsidiary" ||
                          location.pathname === "/corporate-philosophy" ||
                          location.pathname === "/group-company" ||
                          location.pathname === "/team"
                            ? "customBlue font-bold border-b-2 border-red-900 hover:customBlue"
                            : ""
                        }`}
                        aria-current="page"
                      >
                        About Us
                      </button>
                      {isDropdownVisibleAboutUs && (
                        <div className="fixed z-50 duration-300 ease-in-out  backGroundCustom shadow-md rounded w-[300px]">
                          <ul className="">
                          <li className="text-md border-b  border-blue-500  px-4 py-2 uppercase text-white font-jost  hover:text-blue-300 duration-200 ease-in-out">
                              <Link to="/bangladesh-subsidiary">
                                 Company Profile 
                              </Link>
                            </li>
                            <li className="text-md border-b  border-blue-500  px-4 py-2 uppercase text-white font-jost  hover:text-blue-300 duration-200 ease-in-out">
                              <Link to="/corporate-philosophy">
                                Corporate Philosophy
                              </Link>
                            </li>
                            
                            <li className="text-md border-b  border-blue-500  px-4 py-2 uppercase text-white font-jost  hover:text-blue-300 duration-200 ease-in-out">
                              <Link to="group-company">Group Company</Link>
                            </li>
                            <li className="text-md border-b  border-blue-500  px-4 py-2 uppercase text-white font-jost  hover:text-blue-300 duration-200 ease-in-out">
                              <Link to="team">Team</Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </li>
                  <li>
                    <div
                      onMouseEnter={() => toggleDropdownService(true)}
                      onMouseLeave={() => toggleDropdownService(false)}
                    >
                      <button
                        className={`block py-2 px-3 rounded cursor-pointer hover:bg-gray-100 uppercase text-xl text-md font-jost   lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent ${
                          location.pathname.includes("/service")
                            ? "customBlue font-bold border-b-2 border-red-900 hover:customBlue"
                            : ""
                        }`}
                        aria-current="page"
                      >
                        SERVICES
                      </button>

                      {isDropdownVisibleService && (
                        <div className="fixed z-50 duration-300 ease-in-out  backGroundCustom shadow-md rounded w-[300px]">
                          {services.map((service) => (
                            <ul className="">
                              <li className="text-md border-b  border-blue-500  px-4 py-2 uppercase text-white font-jost  hover:text-blue-300 duration-200 ease-in-out">
                                <Link to={`/service/${service._id}`}>
                                  {service.service}
                                </Link>
                              </li>
                            </ul>
                          ))}
                        </div>
                      )}
                    </div>
                  </li>
                  <li>
                    <div
                      onMouseEnter={() => toggleDropdownNews(true)}
                      onMouseLeave={() => toggleDropdownNews(false)}
                    >
                      <button
                        className={`block py-2 px-3 rounded cursor-pointer hover:bg-gray-100 uppercase text-xl text-md font-jost   lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent ${
                          location.pathname.includes("/career-category/") ||
                          location.pathname.includes("/news-details")
                            ? "customBlue font-bold border-b-2 border-red-900 hover:customBlue"
                            : ""
                        }`}
                        aria-current="page"
                      >
                        Column
                      </button>

                      {isDropdownVisibleNews && (
                        <div className="fixed z-50 duration-300 ease-in-out  backGroundCustom shadow-md rounded w-[180px]">
                          {News.map((news) => (
                            <ul className="">
                              <li className="text-md border-b  border-blue-500  px-4 py-2 uppercase text-white font-jost  hover:text-blue-300 duration-200 ease-in-out">
                                <Link to={`/career-category/${news.category}`}>
                                  {news.category}
                                </Link>
                              </li>
                            </ul>
                          ))}
                        </div>
                      )}
                    </div>
                  </li>
                  {/* <li>
                  <Link
                    to="/news"
                    className={`block py-2 px-3 rounded font-jost ${
                      isActive("/news")
                        ? "customBlue font-bold"
                        : "text-gray-900 lg:hover:customBlue"
                    } hover:bg-gray-100 text-xl lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent`}
                  >
                    COLUMN
                  </Link>
                </li> */}
                  <li>
                    <Link
                      to="/gallery"
                      className={`block py-2 px-3 rounded cursor-pointer hover:bg-gray-100 uppercase text-xl text-md font-jost   lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent ${
                        location.pathname.includes("/gallery") ||
                        location.pathname.includes("/gallery-details")
                          ? "customBlue font-bold border-b-2 border-red-900 hover:customBlue"
                          : ""
                      }`}
                    >
                      News
                    </Link>
                  </li>

                  {/* <li>
                  <Link
                    to="/about-us"
                    className={`block py-2 px-3 rounded font-jost ${
                      isActive("/about-us")
                        ? "customBlue font-bold"
                        : "text-gray-900 lg:hover:customBlue"
                    } hover:bg-gray-100 text-xl lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent`}
                  >
                    ABOUT US
                  </Link>
                </li> */}

                  <li>
                    <Link
                      to="/career"
                      className={`block py-2 px-3 rounded cursor-pointer hover:bg-gray-100 uppercase text-xl text-md font-jost   lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent ${
                        location.pathname === "/career" ||
                        location.pathname.includes("/career-details")
                          ? "customBlue font-bold border-b-2 border-red-900 hover:customBlue"
                          : ""
                      }`}
                    >
                      career
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/consultation"
                      className={`block py-2 px-3 rounded font-jost ${
                        isActive("/consultation")
                          ? "customBlue font-bold"
                          : "text-gray-900 lg:hover:customBlue"
                      } hover:bg-gray-100 border-2 p-5 uppercase text-xl lg:hover:bg-transparent lg:border-0 lg:p-0 dark:text-white lg:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent`}
                    >
                      Get free consultation
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* <div
        className={`overlay ${isSidebarOpen ? "active z-50" : ""}`}
        onClick={toggleSidebar}
      ></div> */}
    </div>
  );
};

export default Navbar;
